import { schema } from 'normalizr';
const generateSlug = (entity) => `${entity.priceLevelId}-${entity.priceCodeId}`;

const priceCodeEntity = new schema.Entity(
  'priceCode',
  {},
  { idAttribute: 'id' }
);
const priceLevelEntity = new schema.Entity('priceLevel');
const priceChartItemEntity = new schema.Entity(
  'priceChartItem',
  {},
  { idAttribute: generateSlug }
);
const systemPriceCodeEntity = new schema.Entity('systemPriceCode');
const systemPriceLevelEntity = new schema.Entity('systemPriceLevel');

const arrayOfPriceCodes = new schema.Array(priceCodeEntity);
const arrayOfPriceLevels = new schema.Array(priceLevelEntity);
const arrayOfPriceChartItems = new schema.Array(priceChartItemEntity);
const arrayOfSystemPriceCodes = new schema.Array(systemPriceCodeEntity);
const arrayOfSystemPriceLevels = new schema.Array(systemPriceLevelEntity);

export {
  priceCodeEntity,
  priceLevelEntity,
  priceChartItemEntity,
  arrayOfPriceCodes,
  arrayOfPriceLevels,
  arrayOfSystemPriceLevels,
  arrayOfSystemPriceCodes,
  arrayOfPriceChartItems,
};



// WEBPACK FOOTER //
// ./src/routes/EventDetails/routes/admissions/schema/index.js